export default __webpack_public_path__ + "static/media/credentials-tab.6345158b.svg";